import { render, staticRenderFns } from "./DoneEditing.vue?vue&type=template&id=f2dd7c84&scoped=true"
import script from "./DoneEditing.vue?vue&type=script&lang=js"
export * from "./DoneEditing.vue?vue&type=script&lang=js"
import style0 from "./DoneEditing.vue?vue&type=style&index=0&id=f2dd7c84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2dd7c84",
  null
  
)

export default component.exports